<template>
  <section>
    <qx-search-box
      style="display: none;"
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        form: [
          { // 油卡卡号
            label: '油卡卡号',
            value: 'oilCarNum',
            type: 'input',
            default: '',
            placeholder: '请输入油卡卡号',
          },
          { // 服务商名称
            label: '服务商名称',
            value: 'companyName',
            type: 'input',
            default: '',
            placeholder: '请输入服务商名称',
          },
          { // 油卡状态
            label: '油卡状态',
            value: 'oilCardStatus',
            type: 'input',
            default: '',
            placeholder: '请输入油卡状态',
          },
          { // 油卡类型
            label: '油卡类型',
            value: 'oilCardType',
            type: 'input',
            default: '',
            placeholder: '请输入油卡类型',
          },
          { // 来源类型
            label: '来源类型',
            value: 'cardType',
            type: 'input',
            default: '',
            placeholder: '请输入来源类型',
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData({
        cardCategory: this.$route.path.includes('oil') ? 1 : 2,
        ...searchBoxData,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
